// extracted by mini-css-extract-plugin
export default {"root":"NavigationItem_root__FZ4K-","inline":"NavigationItem_inline__MWs2-","selected":"NavigationItem_selected__hkxAK"};